import { types } from "../actions/ownerEMOChecklist";

const initialState = {
    allotmentDate: null,
    isPossesionAreaDiff: null,
    areaOfExtraLand: null,
    paymentStatus: null,
    agreementDate: null,
    uptodatePaymentStatus: null,
    registryStatus: null
};

export const checklistReducer = (state = initialState, action) => {
    switch (action?.type) {
        case types.UPDATE_CHECKLIST_FORM_FIELD:
            const newState = {
                ...state,
                [action.payload.name]: action.payload.value,
            };
            sessionStorage.setItem("emoCheckList", JSON.stringify(newState));
            return newState
        default:
            return state;
    }
};